import { styled, Typography } from '@mui/material';
import { usePalette, useTranslation } from 'src/hooks';

const StyledTypography = styled(Typography)`
  margin: 0.5rem 0 1rem 0;
`;

export const ErrorLocationMessage = () => {
  const { error } = usePalette();
  const { t } = useTranslation();

  return <StyledTypography color={error.main}>{t('pages.mymes.editor.blobs.no_location_error')}</StyledTypography>;
};
